<!--page starts-->
<section class="page-wrapper">
  <div class="ashton-hero-top-edit-profile">
     <div class="container">
        <div class="edit-profile-detail">
           <div class="red-titel">Edit Profile</div>
           <div class="edit-profile-detail-inner">
              <div class="edit-profile-detail-inner-section">
                 <div class="edit-profile-top">
                    <div class="edit-profile-image">
                       <img [src]="user?.image">
                    </div>
                    <div class="edit-profile-change">
                       <a href="#">Change Photo</a>
                    </div>
                 </div>
                 <div class="edit-profile-bottom">
                    <form  #profileForm="ngForm" (ngSubmit)="Updateprofile(profileForm)">
                      <input type="hidden" id="phone_number" name="phone_number" value="{{user?.phone_number}}" >
                      <input type="hidden" id="email" name="email" value="{{user?.email}}" >
                      <input type="hidden" id="first_name" name="first_name" value="{{user?.first_name}}" >
                      <input type="hidden" id="last_name" name="last_name" value="{{user?.last_name}}" >
                      <input type="hidden" id="birth_date" name="birth_date" value="{{user?.birth_date}}" >  
                      <http-message types="success" [data]="profileSuccess" class="err-msg-block"></http-message>
                      <http-message [type]="'error'" [data]="profileError" *ngIf="profileError" class="err-msg-block"></http-message>
                      <div class="form-group-left half">
                        <div class="form-group">
                            <div class="login-box ashton-signup-form-input-bottom">
                              <app-form-field validation="required" name="first_name" [(ngModel)]="profileRequest.first_name" class="app-group">
                              <label>First Name</label>
                              <input appFieldInput type="text" class="form-control login-input-style" placeholder="First Name" tabindex="1" value="">
                              </app-form-field>
                            </div>
                        </div>
                      </div>
                      <div class="form-group-right half">
                        <div class="login-box ashton-signup-form-input-bottom">
                            <app-form-field validation="required" name="last_name" [(ngModel)]="profileRequest.last_name" class="app-group">
                            <label>Last Name</label>
                            <input appFieldInput type="text" class="form-control login-input-style" placeholder="Last Name" tabindex="2">
                            </app-form-field>
                        </div>
                      </div>
                      <div class="form-group-left">
                        <div class="login-box ashton-signup-form-input-bottom">
                            <app-form-field validation="required" name="email" [(ngModel)]="profileRequest.email" class="app-group">
                            <label>Emaill Address</label>
                            <input appFieldInput type="text" class="form-control login-input-style" placeholder="Email Address" tabindex="4">
                            </app-form-field>
                        </div>
                      </div>
                      <div class="form-group-right">
                        <div class="form-group">
                            <div class="login-box ashton-signup-form-input-bottom">
                              <app-form-field validation="required" name="phone_number" [(ngModel)]="profileRequest.phone_number" class="app-group">
                              <label>Mobile Number</label>
                              <input appFieldInput type="Number" class="form-control login-input-style" placeholder="Number" tabindex="5">
                              </app-form-field>
                            </div>
                        </div>
                      </div>
                      <div class="form-group-left">
                        <div class="form-group">
                            <div class="login-box ashton-signup-form-input-bottom">
                              <app-form-field validation="required" name="birth_date" [(ngModel)]="profileRequest.birth_date" class="app-group">
                              <label>Date of Birth</label>
                              <input type="text/number" class="form-control login-input-style" placeholder="Date of Birth" tabindex="5">
                              </app-form-field>
                            </div>
                        </div>
                      </div>
                      <div class="signup-btn ashton-signup-form-btn">
                        <button type="submit">Update Profile</button>
                      </div>
                    </form>        
                 </div>
              </div>
           </div>
           <div class="want-to-buy-season-tickets-section cf">
              <div class="want-to-buy-season-tickets-left">
                 <h3>Want to buy Season Tickets?</h3>
              </div>
           </div>
        </div>
        <div class="form-group-left">
           <div class="form-group">
              <div class="login-box ashton-signup-form-input-bottom">
                 <app-form-field validation="required" name="birth_date" [(ngModel)]="profileRequest.birth_date"
                 class="app-group">
                 <label>Date of Birth</label>
                 <input type="text" [min]="min" [max]="today" [owlDateTimeTrigger]="start_date_picker"
                 [owlDateTime]="start_date_picker" name="birth_date" [(ngModel)]="profileRequest.birth_date"
                 readonly class="form-control login-input-style" placeholder="Date of Birth" tabindex="5" />
                 </app-form-field>
                 <owl-date-time #start_date_picker pickerType="calendar"></owl-date-time>
              </div>
           </div>
        </div>
        <div class="signup-btn ashton-signup-form-btn">
           <button type="submit">Update Profile</button>
        </div>
    
        <div class="want-to-buy-season-tickets-section cf">
          <div class="want-to-buy-season-tickets-left">
              <h3>Want to buy Season Tickets?</h3>
          </div>
          <div class="want-to-buy-season-tickets-right">
              <div class="want-to-buy-season-tickets-right-image">
                <img src="assets/images/season-ic.png" />
              </div>
          </div>
        </div>
      </div>
    </div>
</section>
<!-- page ends -->